import { render, staticRenderFns } from "./MultipleCheckBox.vue?vue&type=template&id=4388debc&scoped=true&"
import script from "./MultipleCheckBox.vue?vue&type=script&lang=ts&"
export * from "./MultipleCheckBox.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleCheckBox.vue?vue&type=style&index=0&id=4388debc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4388debc",
  null
  
)

export default component.exports